module.exports = __webpack_public_path__ + "static/media/Icon-Star.f02a9cc4.svg";